module.exports = __webpack_public_path__ + "img/tag-11.6ad4d05e.svg";